module.exports = __webpack_public_path__ + "img/logoW.b612963f.svg";